<template>
  <v-container fluid class="user-list" v-if="languageData">
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :right="snackbar.corner === 'right'" :top="snackbar.position === 'top'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>
            <strong>{{ snackbar.title }}</strong>
          </div>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
      <v-col cols="12">
        <v-stepper v-model="e1" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header class="autoheight">
                <v-stepper-step :complete="e1 > 1" @click="setStep(1)" step="1">{{ 'English' }}</v-stepper-step>
                <v-divider></v-divider>

                <v-stepper-step :complete="e1 > 2" @click="setStep(2)" step="2">{{ 'German' }}</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 3" @click="setStep(3)" step="3">{{ 'Polish' }}</v-stepper-step>
              </v-stepper-header>
          </v-card>
          <v-card v-if="translationItems">
            <v-row justify="space-between">
              <v-col class="mt-5 mx-6" col="3">
                <v-btn
                    color="primary"
                    @click="saveTranslations"
                    :loading="dataSaveIsFetching"
                >
                  Save Data
                </v-btn>
              </v-col>
              <v-col class="my-5 mx-6" cols="3">
                <v-text-field
                    label="Search translation"
                    v-model="searchTranslation"
                    @keyup.enter="filterTranslation"
                    outlined
                    dense
                >
                </v-text-field>
              </v-col>
            </v-row>
              <v-stepper-items>
                <v-stepper-content step="1">
                  <TranslationListForm :translationItems="translationItems.gb"></TranslationListForm>
                </v-stepper-content>
                <v-stepper-content step="2">
                  <TranslationListForm :translationItems="translationItems.de"></TranslationListForm>
                </v-stepper-content>
                <v-stepper-content step="3">
                 <TranslationListForm :translationItems="translationItems.pl"></TranslationListForm>
                </v-stepper-content>
              </v-stepper-items>
          </v-card>
        </v-stepper>
    </v-col>

  </v-container>
</template>



<script>
import {mapState, mapActions} from 'vuex';
import eventBus from "../../../event-bus/eventBus";
import TranslationListForm from "../components/TranslationListForm/TranslationListForm";

export default {
  name: "TranslationMain",
  components: {TranslationListForm},
  data() {
    return {
      translationItems: {},
      e1: 1,
      addDebounceTime: 500,
      addTask: null,
      searchTranslation: '',
      snackbar: {
        color: null,
        icon: null,
        mode: null,
        position: "top",
        text: null,
        corner: 'right',
        timeout: 7500,
        title: null,
        visible: false
      },
    }
  },
  computed: {
    ...mapState("getTranslationModule", {
      translationData: state => state.translationData,
      loadingTranslations: state => state.loadingTranslations
    }),
    ...mapState("updateTranslation", {
      dataSaveIsFetching: state => state.dataSaveIsFetching,
      changedItems: state => state.changedItems,
    }),

  },
  methods: {
    ...mapActions("getCompanyUser", ["getCompanyUser"]),
    ...mapActions("getTranslationModule", ["getTranslationModuleRequest"]),
    ...mapActions("updateTranslation", ["updateTranslation"]),

    setStep: function(step) {
      this.e1 = step;
    },

    saveTranslations() {
      this.updateTranslation({ creds: {
              translationData: this.changedItems
            }
      });
    },
    addTranslation(item) {
      this.addToChangedItems(item)
    },
    filterTranslation() {
      eventBus.$emit('filterTranslation', this.searchTranslation);
    },
    getSnackbarSuccess: function(title, message) {
      this.snackbar = {
        color: "success",
        icon: "check_circle",
        mode: "multi-line",
        position: "top",
        timeout: 7500,
        corner: 'right',
        title: title,
        text: message,
        visible: true
      };
    },
    getSnackbarFailure: function(title, message) {
      this.snackbar = {
        color: "failure",
        icon: "error",
        mode: "multi-line",
        position: "top",
        timeout: 7500,
        corner: 'right',
        title: title,
        text: message,
        visible: true
      };
    },
  },
  mounted() {
    this.updateLanguage(this.getCurrentLanguage);
    this.getTranslationModuleRequest();
    eventBus.$on('getTranslationModuleSuccess', (translationData) => {
      this.translationItems = translationData;
    });
    eventBus.$on('saveTranslationSuccess', (dataReceive) => {
      this.getSnackbarSuccess(dataReceive.message, dataReceive.textInfo)
      this.getTranslationModuleRequest();
    })
  },
  beforeDestroy() {
    eventBus.$off('getTranslationModuleSuccess')
    eventBus.$off('saveTranslationSuccess')
  }

}
</script>

